import {Icon, InputAdornment, TextField} from "@material-ui/core";
import React, {useState} from "react";
import {CompactIconButton} from "../components/IconButton";
import {ManagedSortableTable} from "../components/SortableTable";
import VLButton from "../components/VLButton";
import * as Util from "../util/util";
import {useApi, VLScreen2} from "./VLScreen2";

const userListColumns = [
    {name: "Username", field: "username"},
    {name: "Email", field: "email"},
    {name: "Access Level", field: "access_level"},
    {name: ""}
];

const UserList = ({users, myUsername}) => (
    <ManagedSortableTable columns={userListColumns}
                          data={users}
                          initialSort="username"
                          makeRow={e => <UserListItem user={e} me={e.username === myUsername}/>}/>
);

const UserListItem = ({user, me}) => {
    let styleTd = {padding: 8};
    let name = me ? <b>{user.username} (you)</b> : user.username;
    return (
        <tr>
            <td style={styleTd}>{name}</td>
            <td style={styleTd}><a href={"mailto:" + user.email}>{user.email}</a></td>
            <td style={styleTd}>{Util.getAccessLevel(user.access_level)}</td>
            <td style={styleTd}><VLButton href={"/users/" + user.id} title="Manage User"/></td>
        </tr>);
};

const Screen = ({users, username}) => {
    const [search, setSearch] = useState("");

    const searchQuery = search.trim().toLowerCase();
    const filteredUsers = users.filter(user => {
        const searchSpace = [user.username, user.email].map(e => e.toLowerCase());
        return searchSpace.map(e => e.includes(searchQuery)).includes(true);
    });

    return (
        <div style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            padding: 16,
            flexDirection: "column",
            alignItems: "flex-start"
        }}>
            <div style={{display: "flex", width: "100%", alignItems: "center"}}>
                <TextField
                    label="Search"
                    variant="outlined"
                    size="small"
                    value={search}
                    style={{width: 500}}
                    onChange={e => setSearch(e.target.value)}
                    InputProps={{endAdornment: <InputAdornment position="end"><Icon>search</Icon></InputAdornment>}}
                />
                <div style={{flex: 1}}/>
                <CompactIconButton icon="add" title="Add User" href="/users/-1"/>
            </div>
            <br/>
            <UserList users={filteredUsers} myUsername={username}/>
        </div>
    );
};

const Container = () => {

    const [loaded, error, data, reload] = useApi("users/list", {}, []);

    return (
        <VLScreen2 title="Manage Users" error={error} loaded={loaded} retry={reload}>
            {loaded && <Screen {...data}/>}
        </VLScreen2>
    );
};

export default Container;
